<template lang="pug">
.componente-camadas__container(
    :class='{ expandido: visivel }',
    @click.stop='skip'
)
    .componente-camadas__main-outer
        .componente-camadas__pesquisa(v-if='visivel')
            i.el-icon-search
            input(
                v-model='camadaPesquisada',
                type='text',
                :placeholder='$t("mensagens.menuMapa.camadas.pesquisarCamadas")',
                autocomplete='off'
            )
        section.componente-camadas__main(v-if='visivel')
            .el-table__empty-block(v-if='layerVazio')
                span.el-table__empty-text {{ $t('mensagens.menuMapa.camadas.naoEncontrada') }}
            ul.componente-camadas__lista-camadas
                draggable(v-model='layers')
                    li(v-for='(layer, index) in layersFiltrados')
                        span(
                            style='font-size: 15px; margin-right: 5px',
                            v-if='verificarComponente(layer.codigo)'
                        )
                            i.mdi.mdi-drag-vertical(style='margin-right: 5px')
                            i.el-icon-collection-tag(
                                :style='{ color: layer.colorIcon || "#cacaca", "background-color": layer.colorIcon || "#cacaca", "border-radius": "3px", "font-size": "20px" }'
                            )
                        el-switch.opcao-camada(
                            v-model='layer.ativo',
                            @change='onChangeCamada(layer)',
                            v-bind:active-text='i18n.t(`mensagens.camadas.${layer.codigo}`)',
                            v-if='verificarComponente(layer.codigo)'
                        )
                        .componente-camadas__opacidade(
                            v-if='verificarComponente(layer.codigo)'
                        )
                            span {{ $t('mensagens.menuMapa.camadas.opacidade') }}:
                            el-slider(
                                v-model='layer.opacidade',
                                @input='alterarOpacidade(layer)',
                                :disabled='!layer.ativo'
                            )

                        el-collapse(
                            accordion,
                            v-else-if='verificarComponenteComAccordion(layer.codigo)'
                        )
                            el-collapse-item
                                template(slot='title')
                                    i.mdi.mdi-drag-vertical.collapse-icon(
                                        style='margin-right: 5px'
                                    )
                                    el-switch(
                                        v-model='layer.ativo',
                                        @change='onChangeCamada(layer)',
                                        v-bind:active-text='layer.nome'
                                    )
                                p(
                                    v-if='layer.subtitle !== undefined',
                                    v-for='item in layer.subtitle'
                                )
                                    span(
                                        style='font-size: 15px; margin-right: 5px'
                                    )
                                        i.el-icon-collection-tag(
                                            :style='{ color: item.colorIcon || "#cacaca", "background-color": item.colorIcon || "#cacaca", "border-radius": "3px" }'
                                        )
                                    span {{ item.name }}

                                .componente-camadas__opacidade__biomas
                                    span {{ $t('mensagens.menuMapa.camadas.opacidade') }}:
                                    el-slider(
                                        v-model='layer.opacidade',
                                        @input='alterarOpacidade(layer)',
                                        :disabled='!layer.ativo'
                                    )

                        CamadasAccordion(
                            v-else,
                            :layer='layer',
                            :alterar-opacidade='alterarOpacidade',
                            :on-change-camada='onChangeCamada',
                            :layersFiltrados='subCamadas'
                        )

    button.componente-camadas__botao-controle(@click='toggle')
        i.mdi.mdi-layers-outline
        span.text-align-center(v-show='!visivel') {{ $t('mensagens.menuMapa.camadas.titulo') }}
</template>

<script>
import L from 'leaflet';
import { URL_GEOSERVER } from '@/utils/mapa/mapa.config';

import { GeoService, CamadasService } from '@/services/CamadasService';
import camadasVisualizacao from '@/utils/camadas.js';

import estilos from '@/utils/mapa/mapa.estilos';
import Mapa from '@/utils/mapa/mapa.service';

import store from '@/store';
import draggable from 'vuedraggable';
import CamadasAccordion from './CamadasAccordion.vue';

import _ from 'lodash';

export default {
    components: {
        draggable,
        CamadasAccordion
    },
    props: {
        mapa: {
            type: Object,
            required: true
        },
        showStatesLayers: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data() {
        return {
            subCamadas: [],
            visivel: false,
            camadaPesquisada: '',
            layers: [],
            layersFiltrados: [],
            resultados: [],
            layerGeometrias: L.featureGroup(),
            geometria: null,
            markers: null,
            classLista: 'componente-camadas__lista-camadas',
            inputTeclas: '',
            layerVazio: false,
            camadasOcultas: []
        };
    },
    computed: {
        ativarCamadaCar() {
            return store.state.ativarCamadaCar;
        },
        carSelecionadoNaPopup() {
            return store.state.carSelecionadoNaPopup;
        },
        showCamadaToEdit_() {
            return {
                flag: store.state.showCamadaToEdit,
                identifier: store.state.identificadorGeometria
            };
        },
        geometriaToShow() {
            return store.state.geometriaToShow;
        },
        identificadorGeometria() {
            return store.state.identificadorGeometria;
        },
        limparUltimaGeometria() {
            return store.state.limparUltimaGeometria;
        },
        limparCamadas() {
            return store.state.limparCamadas;
        }
    },
    created() {
        this.$bus.$off();

        CamadasService.buscarCamadasUsuario()
            .then(({ data }) => {
                if (data) {
                    this.layers = [...camadasVisualizacao].filter(camada =>
                        data.includes(camada.codigo)
                    );

                    this.layersFiltrados = this.layers;

                    this.subCamadas = this.layers.filter(layer => {
                        return [
                            'PY_LOCALIDADE_NIVEL_1',
                            'PY_LOCALIDADE_NIVEL_2',
                            'TERRA_INDIGENA_PARAGUAI'
                        ].includes(layer.codigo);
                    });

                    this.layers.forEach(layer => {
                        const url = layer.local ? URL_GEOSERVER : layer.path;
                        let options = {
                            codigo: layer.codigo,
                            layers: layer.layerName,
                            transparent: true,
                            format: 'image/png',
                            idEmpresa: '',
                            path: layer.path,
                            styles: layer.styleName || '',
                            opacity: layer.opacidade / 100
                        };
                        if (layer.cql_filter) {
                            options.cql_filter = layer.cql_filter;
                        }
                        layer.leafletLayer = L.tileLayer.wms(url, options);
                        if (layer.ativo) {
                            layer.ativo = false;
                            this.desativarCamada(layer.leafletLayer);
                        }

                        const camadaEstados = this.layers.find(
                            l => l.codigo === 'ESTADOS'
                        );

                        if (camadaEstados && this.showStatesLayers) {
                            camadaEstados.ativo = true;
                            setTimeout(() => {
                                this.ativarCamada(camadaEstados.leafletLayer);
                            }, 500);
                        }
                    });

                    this.layers = this.layers.filter(layer => {
                        return !layer.codigo.startsWith('PY');
                    });
                } else {
                    this.$notify.error({
                        message: this.$t('mensagens.menuMapa.camadas.erro')
                    });
                }
            })
            .catch(erro => {
                this.$notify.error({
                    message: this.$t('mensagens.menuMapa.camadas.erro')
                });
            });
    },
    methods: {
        verificarParaguai(layer) {
            return layer.codigo === 'PY_LOCALIDADE_NIVEL_1';
        },
        toggle() {
            this.visivel = !this.visivel;
        },
        onChangeCamada(camada) {
            if (camada.ativo) {
                this.mapa.removeLayer(camada);
                this.ativarCamada(camada.leafletLayer);
            } else {
                this.desativarCamada(camada.leafletLayer);
            }
            this.orderLayer(this.layers);
        },
        ativarCamada(camada) {
            this.mapa.addLayer(camada);
            this.atualizarListaCamadasDiagnostico();
        },
        desativarCamada(camada) {
            this.clearLayers();
            this.mapa.removeLayer(camada);
            this.atualizarListaCamadasDiagnostico();
        },
        ativarCamadaCAR() {
            const camadaCar = this.layers.find(
                l => l.codigo === 'IMOVEL_RURAL'
            );
            if (camadaCar && !camadaCar.ativo) {
                camadaCar.ativo = true;
                this.onChangeCamada(camadaCar);
                this.mapa.on('click', this.buscar, this);
            }
        },
        atualizarListaCamadasDiagnostico() {
            const camadasAtivas = this.layers.filter(l => l.ativo === true);
            this.$bus.$emit('mapa:camadas-ativas-diagnostico', camadasAtivas);
        },
        desativarCamadaCAR() {
            const camadaCar = this.layers.find(
                l => l.codigo === 'IMOVEL_RURAL'
            );
            camadaCar.ativo = false;
            setTimeout(() => {
                this.clearLayers();
                this.mapa.removeLayer(camadaCar.leafletLayer);
                this.atualizarListaCamadasDiagnostico();
            }, 500);
            this.mapa.off('click', this.buscar, this);
        },
        skip() {},
        clearLayers() {
            if (this.geometria) {
                if (store.state.territoryTableData.length) {
                    const existeNaTabela = store.state.territoryTableData.find(
                        t =>
                            t.identificadorGeometria ===
                            this.geometria.identificadorGeometria
                    );
                    if (!existeNaTabela) {
                        this.mapa.removeLayer(this.geometria);
                    }
                } else {
                    this.mapa.removeLayer(this.geometria);
                }
                this.geometria = null;
                store.dispatch('setCarSelecionadoNaPopup', null);
            }
        },
        limparUltimaGeometriaSelecionadaCar() {
            if (this.geometria) {
                if (store.state.territoryTableData.length) {
                    const existeNaTabela = store.state.territoryTableData.find(
                        t =>
                            t.identificadorGeometria ===
                            this.geometria.identificadorGeometria
                    );
                    if (!existeNaTabela) {
                        this.mapa.removeLayer(this.geometria);
                    }
                } else {
                    this.mapa.removeLayer(this.geometria);
                }
                this.geometria = null;
            }
            store.dispatch('setLimparUltimaGeometria', false);
        },
        buscar(e) {
            GeoService.getCarPorCoordenadas(e.latlng.lat, e.latlng.lng).then(
                ({ data }) => {
                    if (!data[0].resultados || !data[0].resultados.length) {
                        return;
                    }

                    this.resultados = data[0].resultados;

                    this.resultados.forEach(resultado => {
                        this.clearLayers();
                        this.geometria = Mapa.criarGeoJSON(
                            resultado.geometry,
                            estilos.Geometria.imovelRuralCandidato
                        );
                        resultado.properties.identificadorGeometria =
                            this.geometria._leaflet_id;
                        this.geometria.identificadorGeometria =
                            this.geometria._leaflet_id;

                        store.dispatch('setCarSelecionadoNaPopup', resultado);
                        this.mapa.addLayer(this.geometria);
                        var bounds = this.geometria.getBounds();
                        this.mapa.fitBounds(bounds);

                        this.$nextTick(() => {
                            const popup = document.getElementById('popup');
                            if (popup) {
                                popup.style.display = 'block';
                            }

                            this.geometria.openPopup();
                        });
                    });
                }
            );
        },
        carWasSelectedBefore(carCode) {
            let result = false;
            if (store.state.territoryTableData.length === 0) {
                result = false;
            } else {
                store.state.territoryTableData.forEach(item => {
                    if (item.codigo === carCode) {
                        result = true;
                    }
                });
            }
            return result;
        },
        onCarSelecionadoNaPopup(codigoCAR) {
            let resultado = this.resultados.find(
                r => r.properties.codigo === codigoCAR
            );
            if (resultado) {
                let type = 'CAR';
                resultado = { ...resultado, ...resultado.properties, type };
                delete resultado.properties;
                if (!this.carWasSelectedBefore(resultado.codigo)) {
                    store.dispatch('setTerritoryTableData', resultado);
                } else {
                    this.$notify.error({
                        message: 'CAR já selecionado!'
                    });
                }
                store.dispatch('setCarSelecionadoNaPopup', null);

                this.geometria = null;
            }
        },
        showCamadaToEdit(geometriaToShow, identificadorGeometria) {
            this.clearLayers();
            this.geometria = Mapa.criarGeoJSON(
                geometriaToShow,
                estilos.Geometria.imovelRuralCandidato
            );
            this.geometria.identificadorGeometria = identificadorGeometria;
            this.mapa.addLayer(this.geometria);
            var bounds = this.geometria.getBounds();

            // Fit the map to the polygon bounds
            this.mapa.fitBounds(bounds);
            store.dispatch('setShowCamadaToEdit', {
                showCamadaToEdit: true,
                geometriaToShow: geometriaToShow,
                identificadorGeometria: identificadorGeometria
            });
        },
        orderLayer(list) {
            let mapa = this.mapa;
            let tam = list.length - 1;

            for (let i = tam; i >= 0; i--) {
                Object.entries(this.mapa._layers).map(function (item) {
                    if (
                        item[1]['wmsParams'] !== undefined &&
                        list[i].layerName === item[1]['wmsParams']['layers']
                    ) {
                        mapa._layers[item[0]].bringToFront();
                    }
                });
            }
        },
        alterarOpacidade({ leafletLayer, opacidade }) {
            leafletLayer.setOpacity(opacidade / 100);
        },
        // Verificacao de componentes com sublista
        verificarComponente(codigoCamada) {
            const subCamadas = [
                'BIOMAS',
                'COBERTURA_SOLO_MAPBIOMAS',
                'CARS_CLASSIFICADOS',
                'CARS_DECLARADOS',
                'PY_LOCALIDADE_NIVEL_1',
                'PY_LOCALIDADE_NIVEL_2',
                'TERRA_INDIGENA_PARAGUAI'
            ];

            return !subCamadas.includes(codigoCamada);
        },

        verificarComponenteComAccordion(codigoCamada) {
            const subCamadas = [
                'PY_LOCALIDADE_NIVEL_1',
                'PY_LOCALIDADE_NIVEL_2',
                'TERRA_INDIGENA_PARAGUAI'
            ];

            return !subCamadas.includes(codigoCamada);
        }
    },
    watch: {
        layers(list) {
            this.orderLayer(list);
            this.layersFiltrados = this.layers;
        },

        camadaPesquisada(value) {
            this.layersFiltrados = this.layers.filter(layer =>
                layer.nome.toLowerCase().includes(value.toLowerCase())
            );

            if (this.layersFiltrados.length === 0) {
                this.layerVazio = true;
            } else {
                this.layerVazio = false;
            }
        },

        ativarCamadaCar: {
            handler: _.debounce(function (newValue) {
                if (newValue) {
                    this.ativarCamadaCAR();
                } else {
                    this.desativarCamadaCAR();
                }
            }, 100)
        },

        carSelecionadoNaPopup(newValue) {
            if (newValue) {
                this.onCarSelecionadoNaPopup(newValue);
            }
        },

        showCamadaToEdit_(flag, identifier) {
            if (flag || identifier) {
                this.showCamadaToEdit(
                    this.geometriaToShow,
                    this.identificadorGeometria
                );
            }
        },

        limparUltimaGeometria(newValue) {
            if (newValue) {
                this.limparUltimaGeometriaSelecionadaCar();
            }
        },

        limparCamadas(newValue) {
            if (newValue) {
                const camadaCar = this.layers.find(
                    l => l.codigo === 'IMOVEL_RURAL'
                );
                this.desativarCamada(camadaCar);
                store.dispatch('setLimparCamadas', false);
            }
        }
    }
};
</script>

<style lang="scss">
.leaflet-control-camadas {
    box-shadow: none !important;
    border: none !important;
}

.componente-camadas__botao-controle {
    cursor: pointer;

    i {
        font-size: 20px;
        line-height: 30px;
        position: relative;
    }

    span {
        position: relative;
        top: -6px;
    }
}

.componente-camadas__container {
    border: 2px solid rgba(0, 0, 0, 0.2);
    background-clip: padding-box;
    border-radius: 4px;
    margin-right: -2px !important;
}

.componente-camadas__container {
    &.expandido {
        position: static;
        display: flex;
        justify-content: flex-end;

        .componente-camadas__botao-controle {
            width: 32px !important;

            i {
                color: #0a9a84;
            }
        }
    }
}

.componente-camadas__main-outer {
    border-radius: 4px;
    width: 100%;
    overflow: hidden;
}

.componente-camadas__main {
    background-color: var(--white);
    border-radius: 4px;
    width: 412px;
    height: 250px;
    overflow-y: auto;
    margin-left: 5px !important;
    padding: 6px 6px 59px 6px;
}

.componente-camadas__pesquisa {
    height: 42px;
    width: 96%;
    margin: 10px 4px 6px;
    display: flex;
    justify-content: center;
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);

    i.el-icon-search {
        display: flex;
        color: var(--primary);
        font-size: 20px;
        margin-left: 8px;
        font-weight: bold;
        align-items: center;
    }

    input {
        width: 100%;
        height: 80%;
        margin: 5px;
        border: none;
        outline: none;
        font-size: 14px;
        color: var(--primary);
        border-radius: 5px;
    }
}

.el-table__empty-block {
    padding-top: 10px;
}

.el-table__empty-text {
    text-align: center;
    align-items: center;
    font-size: 14px;
}

.componente-camadas__lista-camadas {
    list-style: none;
    padding-inline-start: 0px;
    margin: 0;
    padding: 0;

    li {
        margin-bottom: 5px !important;
        word-wrap: break-word !important;
        background-color: rgb(255 255 255) !important;
        background-clip: border-box !important;
        border: 1px solid rgb(0 0 0 / 13%) !important;
        border-radius: 0.25rem !important;
        padding: 5px !important;
    }

    .el-checkbox__label {
        font-size: 13px;
    }
}

.el-switch.opcao-camada .el-switch__core {
    width: 30px !important;
}

.el-switch.is-checked .el-switch__core::after {
    margin-left: -11px !important;
}

.el-switch__core:after {
    width: 10px !important;
    height: 11px !important;
}

.el-switch__core {
    height: 15px !important;
}

.leaflet-control-camadas-base {
    margin-right: 12px !important;
}

.el-collapse-item__header .el-switch__core {
    width: 30px !important;
}

.leaflet-control-camadas-base .el-collapse-item__content {
    padding-bottom: 0px !important;
}

i.collapse-icon {
    height: 50px;
}

.el-switch {
    vertical-align: initial !important;
}

.componente-camadas__opacidade {
    display: flex;
    width: 100%;
    gap: 16px;
    margin-left: 6px;
}

.componente-camadas__opacidade__biomas {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 16px;
    margin-left: 6px;

    .el-slider {
        width: 65% !important;
    }
}

.el-slider {
    width: 70%;
    height: 20px;
}

.el-slider__runway {
    margin-top: 5px !important;
    margin-bottom: 0px;
}
</style>
